
import { useState, useEffect } from 'react';

interface NavbarProps {
  activeSection: string;
}

export default function Navbar({ activeSection }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    setMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'Sobre' },
    { id: 'menu', label: 'Cardápio' },
    { id: 'gallery', label: 'Galeria' },
    { id: 'testimonials', label: 'Depoimentos' },
    { id: 'order', label: 'Pedidos' },
    { id: 'contact', label: 'Contato' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || menuOpen ? 'bg-black shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('home')}>
            <img
              src="https://static.readdy.ai/image/ee4ab35536c43b833838f71f4d3b75cf/a5bb4558efa960a1896a0fe4ecddc296.png"
              alt="Buckets Chicken Logo"
              className="h-10 w-10 md:h-14 md:w-14 object-contain"
            />
            <span className="ml-2 text-lg md:text-2xl font-bold text-yellow-400">Buckets Chicken</span>
          </div>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  activeSection === item.id
                    ? 'bg-yellow-400 text-black'
                    : 'text-white hover:bg-red-700'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <a
            href="https://wa.me/5519971394274"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:block bg-yellow-400 text-black px-6 py-2 rounded-full font-bold hover:bg-yellow-300 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Fazer Pedido
          </a>

          {/* Hamburguer mobile */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-black border-t border-yellow-400/30 px-4 pb-4">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className={`w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-all duration-300 cursor-pointer ${
                activeSection === item.id
                  ? 'bg-yellow-400 text-black'
                  : 'text-white hover:bg-red-700'
              }`}
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://wa.me/5519971394274"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 w-full block text-center bg-yellow-400 text-black px-6 py-3 rounded-full font-bold hover:bg-yellow-300 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Fazer Pedido
          </a>
        </div>
      )}
    </nav>
  );
}
